module.exports = __webpack_public_path__ + "04_face.98dda631.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer1/04_face.png
// module id = sqng
// module chunks = 0